export type SorcImageSizes = 'thumbnail' | 'small' | 'medium';

export enum SorcImageView {
  // FrontLeft should be first: SSM-2059 as images are displayed in order of keys in this enum
  FrontLeft = 540001,
  RearLeft = 540003,
  Front = 540005,
  Rear = 540006,
  LateralLeft = 540007,
  LateralRight = 540008,
  Interior = 540011,
  DashBoard = 540012,
  CargoSpace = 540013,

  /**
   * Currently not used, all enum members are used to download Sorc images,
   * if uncommented, system will try to download them.
   */
  // FrontRight = 540002,
  // RearRight = 540004,
  // TopViewFront = 540009,
  // TopViewRear = 540010,
  // DetailOptionsInterior = 540014,
  // DetailOptionsExterior = 540015,
  // Engine = 540016,
  // Transmission = 540017,
  // DriveSuspension = 540018,
  // Body = 540019,
  // XRayView = 540020,
  // SectionalView = 540021,
  // Badge_Logo = 540022,
  // Miscellaneous = 540023,
  // NoLink = 549999,
}
